import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../account/components/ProtectedRoute";
import { AdminAnnouncementsPage } from "../admin/pages/AdminAnnouncementsPage";
import { AdminLeadsPage } from "../admin/pages/AdminLeadsPage";
import { AdminPaymentsPage } from "../admin/pages/AdminPaymentsPage";
import { AdminPlayersPage } from "../admin/pages/AdminPlayersPage";
import { AdminAssessmentsPage } from "../admin/pages/AdminAssessmentsPage";
import { PlayerReportPage } from "../dashboard/pages/PlayerReportPage";
import { StaffLayout } from "./components/StaffLayout";
import { StaffDashboardPage } from "./pages/StaffDashboardPage";
import { StaffEnrollmentsPage } from "./pages/StaffEnrollmentsPage";
import { StaffSchedulePage } from "./pages/StaffSchedulePage";
import { StaffSettingsPage } from "./pages/StaffSettingsPage";

export function StaffRoutes() {
  return (
    <Routes>
      <Route
        path="/staff"
        element={
          <ProtectedRoute allow={["staff"]}>
            <StaffLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<StaffDashboardPage />} />
        <Route path="schedule" element={<StaffSchedulePage />} />
        <Route path="enrollments" element={<StaffEnrollmentsPage />} />
        <Route path="leads" element={<AdminLeadsPage />} />
        <Route path="payments" element={<AdminPaymentsPage />} />
        <Route path="announcements" element={<AdminAnnouncementsPage />} />
        <Route path="players" element={<AdminPlayersPage />} />
        <Route path="players/:playerId/report" element={<PlayerReportPage />} />
        <Route path="assessments" element={<AdminAssessmentsPage />} />
        <Route path="settings" element={<StaffSettingsPage />} />
        <Route path="*" element={<StaffDashboardPage />} />
      </Route>
    </Routes>
  );
}
